import { useState } from "react";
import { useStore } from "../data/store";
import { Btn, Empty } from "../ui/bits";
import { useToast } from "../ui/Toast";

/**
 * «ذهنم» — سبد سریع. هدفش این است که فکر از سر کاربر بیرون بیاید، نه دسته‌بندی شود.
 *
 * درس تست کاربر: دکمهٔ «← کار» مبهم بود — کاربر فکر کرد آیتم را حذف می‌کند،
 * بعد اتفاقی در «امروز» پیدایش کرد. حالا دکمه می‌گوید دقیقاً کجا می‌رود،
 * و توست هم مقصد را می‌گوید و امکان برگشت می‌دهد.
 */
export function Mind() {
  const { state, dispatch } = useStore();
  const toast = useToast();
  const [text, setText] = useState("");
  const open = state.mind.filter((m) => !m.processedAt);

  const toTask = (id: string, label: string) => {
    dispatch({ type: "processMind", id, asTask: true });
    toast(`«${label}» به کارهای امروز رفت`, {
      undo: () => dispatch({ type: "restoreMind", id }),
    });
  };

  return (
    <div className="screen">
      <header className="daybar">
        <div><h1>ذهنم</h1><span>هرچه در سرت است، همین‌جا بگذار</span></div>
      </header>

      <form
        className="mind-form"
        onSubmit={(e) => {
          e.preventDefault();
          const v = text.trim();
          if (!v) return;
          dispatch({ type: "addMind", text: v });
          setText("");
          toast("ثبت شد", { tone: "info" });
        }}
      >
        <input
          className="input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="مثلاً: به دکتر زنگ بزنم"
        />
        <Btn type="submit">ثبت</Btn>
      </form>

      {open.length === 0 ? (
        <Empty icon="🧠" title="ذهنت خالی است" hint="این حالت خوبی است." />
      ) : (
        <>
          <p className="hint" style={{ marginTop: 2 }}>
            هر چیزی که به کار تبدیل شود، در تب «امروز» پیدایش می‌کنی.
          </p>
          <ul className="mindlist">
            {open.map((m) => (
              <li key={m.id}>
                <span className="mindtext">{m.text}</span>
                <div className="mind-acts">
                  <button className="mind-primary" onClick={() => toTask(m.id, m.text)}>
                    ← کارهای امروز
                  </button>
                  <button
                    className="mind-del"
                    aria-label="حذف"
                    onClick={() => {
                      dispatch({ type: "removeMind", id: m.id });
                      toast("حذف شد", { tone: "info" });
                    }}
                  >
                    حذف
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
